import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { SECTION_LABELS } from 'src/app/core/constants/profile.constants';

@Component({
  selector: 'identity',
  imports: [],
  templateUrl: './identity.component.html',
  styleUrl: './identity.component.scss',
})
export class IdentityComponent implements OnInit {
  sectionLabels = SECTION_LABELS;
  userName = '';

  constructor(private readonly authService: MsalService) {}
  ngOnInit(): void {
    const activeAccount = this.authService.instance.getActiveAccount();
    this.userName = activeAccount?.name ?? this.sectionLabels.USER_NAME;
  }
}
